<div class="row" *ngIf='readOnly'>
  <div class="col-md-12 col-sm-12 table-responsive no-border">
      <form [formGroup]="deviceForm" novalidate>
          <table class="table table-inner table-condensed table-striped table-66">
              <tbody>
                  <tr>
                      <th>Product Designer SRN</th>
                  </tr>
                  <tr>
                      <td [ngClass]="isDefault('Product Designer SRN')">
                          <label controlName="productDesignerSRN"> </label> </td>
                  </tr>
              </tbody>
          </table>

          <table formArrayName="designerForm" class="table table-inner table-condensed table-striped table-66">
              <tbody>
                  <tr>
                      <th class="col-sm-6">Product Designer Name</th>
                  </tr>
                  <ng-container *ngIf="designerForm?.controls?.length; else emptyTemplate1fields">
                  <tr formGroupName="{{i}}"
                      *ngFor="let sizeGroup of designerForm.controls; let i = index">
                      <td [ngClass]="isDefault('Product Designer Names')">
                          <label controlName="name"></label>
                      </td>
                  </tr>
                  </ng-container>
              </tbody>
          </table>
          <table class="table table-inner table-condensed table-striped">
              <tbody>
                  <tr>
                      <th>Street Name</th>
                      <th>Street Number</th>
                      <th *ngIf="dataScope?.toLowerCase() !== 'swissdamed'">Address Complement</th>
                      <th *ngIf="dataScope?.toLowerCase() !== 'swissdamed'">PO Box</th>
                      <th>City</th>
                      <th>Postal Code</th>
                      <th>Country</th>
                  </tr>
                  <tr>
                      <td [ngClass]="isDefault('Street Name')"> <label
                              controlName="streetName"></label></td>
                      <td [ngClass]="isDefault('Street Number')"> <label
                              controlName="streetNumber"></label></td>
                      <td *ngIf="dataScope?.toLowerCase() !== 'swissdamed'" [ngClass]="isDefault('Address Complement')"> <label
                              controlName="addressComplement"></label></td>
                      <td *ngIf="dataScope?.toLowerCase() !== 'swissdamed'" [ngClass]="isDefault('PO Box')"> <label controlName="poBox"></label>
                      </td>
                      <td [ngClass]="isDefault('City')"> <label controlName="city"></label></td>
                      <td [ngClass]="isDefault('Postal Code')"> <label
                              controlName="postalCode"></label></td>
                      <td [ngClass]="isDefault('Country')"> <label controlName="country"></label>
                      </td>
                  </tr>
              </tbody>
          </table>

          <table formArrayName="publicContactForm" class="table table-inner table-condensed table-striped table-66">
              <tbody>
                  <tr>
                      <th class="col-sm-6">Email</th>
                      <th class="col-sm-6">Telephone</th>
                  </tr>
                  <ng-container *ngIf="publicContactForm?.controls?.length; else emptyTemplate2fields">
                  <tr formGroupName="{{i}}"
                      *ngFor="let sizeGroup of publicContactForm.controls; let i = index">
                      <td [ngClass]="isDefault('Product Designer Contacts')">
                          <label controlName="email"></label>
                      </td>
                      <td [ngClass]="isDefault('Product Designer Contacts')">
                          <label controlName="telephone"></label>
                      </td>
                  </tr>
                  </ng-container>
              </tbody>
          </table>
      </form>
  </div>
</div>
<ng-template #emptyTemplate2fields>
  <tr>
    <td role="gridcell"><label></label></td>
    <td role="gridcell"><label></label></td>
  </tr>
</ng-template>
<ng-template #emptyTemplate1fields>
  <tr>
    <td role="gridcell"><label></label></td>
  </tr>
</ng-template>
